export default __webpack_public_path__ + "static/media/Group 3178@2x.70439256.png";